<header class="short-header">
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="title-container"
    >
      <h2>
        Partenerii
        <span class="after-title">
          {{ agencyService.agency.name }}
        </span>
      </h2>
    </div>
  </div>
  <div
    class="header-image-container"
    style="background-image: url('/assets/images/partners/header_background.jpg')"
  >
  </div>
</header>

<section
  class="partners-list"
  fxLayout="row wrap"
  fxLayoutAlign="center stretch"
  fxLayoutAlign.gt-xs="center center"
  [style.minHeight.px]="pageHeight"
>
  <div
    class="partner-item"
    fxLayout="column"
    fxLayoutAlign="center center"
    *ngFor="let partner of partners"
  >
    <img
      class="partner-avatar"
      [src]="partner.image.url"
      alt=""
    >
    <h4
      class="partner-name"
    >
      {{ partner.name }}
    </h4>
    <p
      class="partner-description"
    >
      {{ partner.description | truncate:100 }}
    </p>
    <button
      mat-raised-button
      color="secondary"
      (click)="openPartnerModal(partner)"
      class="partner-item-link"
    >
      vezi mai multe
    </button>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.html